











import { Component, Prop, Vue } from 'vue-property-decorator';
import Car from '@/entities/Car';
import CarService from '@/services/car';
import CarTile from '../CarTile.vue';

@Component({
    components: {
        CarTile,
    },
})
export default class CarsMock extends Vue {
    @Prop()
    numberOfCars: number;

    carService = new CarService();

    get cars(): Car[] {
        if (this.numberOfCars) {
            return this.carService.list.slice(0, this.numberOfCars);
        }

        return this.carService.list;
    }
}
